import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Create axios instance
const apiClient = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('pera_admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('pera_admin_token');
      window.location.href = '/admin/login';
    }
    return Promise.reject(error);
  }
);

// Public API
export const publicApi = {
  // Health check
  health: () => axios.get(`${API}/health`),
  
  // Contact form
  submitContact: (data) => axios.post(`${API}/contact`, data),
  
  // Projects (public)
  getProjects: () => axios.get(`${API}/projects`),
  getProject: (id) => axios.get(`${API}/projects/${id}`),
};

// Admin API
export const adminApi = {
  // Auth
  login: (data) => axios.post(`${API}/admin/login`, data),
  getMe: () => apiClient.get('/admin/me'),
  
  // Contacts
  getContacts: () => apiClient.get('/admin/contacts'),
  updateContactStatus: (id, newStatus) => 
    apiClient.patch(`/admin/contacts/${id}/status?new_status=${newStatus}`),
  deleteContact: (id) => apiClient.delete(`/admin/contacts/${id}`),
  
  // Projects (admin)
  createProject: (data) => apiClient.post('/admin/projects', data),
  updateProject: (id, data) => apiClient.patch(`/admin/projects/${id}`, data),
  deleteProject: (id) => apiClient.delete(`/admin/projects/${id}`),
  uploadImage: (file) => {
    const fd = new FormData();
    fd.append('file', file);
    return apiClient.post('/admin/upload', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
};

// Seed functions (for initial setup)
export const seedApi = {
  seedAdmin: () => axios.post(`${API}/admin/seed`),
  seedProjects: () => axios.post(`${API}/seed/projects`),
};

export default apiClient;
